import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {SponsorshipsRepository} from "./sponsorships.repository";
import {SponsorshipsFactory} from "./sponsorships.factory";
import {SponsorshipDomainModel} from "../models/sponsorship.domain-model";
import {SponsorshipApiModel} from "../models/sponsorship.api-model";
import {SponsorshipsRequestParams} from "../models/sponsorships.request-params";
import {InitialRequestParams} from "../../../core/models/initial-request-params";

export class SponsorshipsDomainService extends BaseDomainService {
  repository: SponsorshipsRepository;

  static injectables = [...BaseManagedService.injectables, SponsorshipsRepository, SponsorshipsFactory, DomainRequestManager];

  async fetch(params: SponsorshipsRequestParams) {
    const initialRequestParams: InitialRequestParams = this.createInitialRequestParams();
    const userCountryId: Number = initialRequestParams.userCountryId;
    const sponsorships: Array<SponsorshipDomainModel> = this._getSponsorshipByUserCountryId(userCountryId);

    return Promise.resolve({sponsorships});
  }

  _getSponsorshipByUserCountryId(userCountryId: Number) {
    const sponsorship: SponsorshipDomainModel = this.sponsorships.filter((sponsorship: SponsorshipDomainModel) => sponsorship.countryIds.includes(userCountryId))

    return sponsorship;
  }

  get sponsorships(): Array<SponsorshipDomainModel> {
    const sponsorships: Array<SponsorshipDomainModel> = this.repository.sponsorships.map((sponsorship: SponsorshipApiModel) => {
      return this.factory.createDomainModel(sponsorship);
    });

    return sponsorships;
  }
}
